<p-card class="base-card">
  <ng-content></ng-content>
</p-card>
